import React from 'react';
import { isMobile } from 'react-device-detect';
import { observer } from 'mobx-react';

import SubscriptionModal from '../generalComponents/SubscriptionModal';
import VideoPlayerStore from '../../store/VideoPlayerStore';

import ProgramTags from './ProgramTags';


class PlayerInfo extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      showTranscript: false,
      showSubscriptionModal: false,
    };
  }

  render() {
    const { isSubscribed } = this.props;
    const {
      programSegments,
      currentPosition,
      program,
      truncate,
      titleDate,
      handleTranscript,
      showTranscript,
    } = VideoPlayerStore;

    if (!programSegments) {
      return null;
    }

    return (
      <>
        <div className={`player-info ${isMobile && !isSubscribed && 'mobile-subscribe-position'}`}>
          {!isMobile &&
            <div className="player-title">
              <div className="player-title-name">
                {programSegments?.[currentPosition]?.segment?.name !== '' ? programSegments?.[currentPosition]?.segment?.name : program?.nextSegmentCategory}
                <div className="player-title-date">
                  {titleDate}
                </div>
              </div>
              <div className="player-title-tags" />
            </div>}
        </div>
        {this.state.showSubscriptionModal &&
          <React.Suspense fallback={null}>
            <SubscriptionModal
              closeModal={this.closeSubscriptionModal}
              show={this.state.showSubscriptionModal}
            />
          </React.Suspense>}
        <>
          <div className="video-transcript clearfix">
            <a
              className={showTranscript ? 'in' : ''}
              href="javascript:void(0);"
              onClick={handleTranscript}
            >
              <span className="h3 text-white">
                Transcript
              </span>
              <span
                className="copy"
                style={{ marginRight: '5px' }}
              >
                {programSegments?.[currentPosition]?.description !== '' ? truncate(programSegments?.[currentPosition]?.description) : 'N/A'}
              </span>
              {programSegments?.[currentPosition]?.description !== '' && (<span className="link">
                <span className="more">
                  Read More &gt;&gt;
                </span>
                <span className="hide-btn">
                  Hide &gt;&gt;
                </span>
              </span>)}
            </a>
            <div
              className={
                showTranscript ? 'collapse in' : 'collapse'
              }
              dangerouslySetInnerHTML={{ __html: programSegments?.[currentPosition]?.description !== '' ? programSegments?.[currentPosition]?.description : 'N/A' }}
            />
            <ProgramTags programData={programSegments?.[currentPosition]} />
          </div>
        </>
      </>
    );
  }
}

export default observer(PlayerInfo);
